import Card from '../../organisms/Card';
import Button from '../../atoms/button';
import { useContext, useState } from 'react';
import ModalContext from '../../../utils/ModalContext';
import cookiesImg from '../../../assets/images/cookies.svg';

export default function CookiePopup() {
  const { showCookieModal } = useContext(ModalContext);

  const storage = localStorage.getItem('cookieConsent');
  const cookieConsent = storage ? (JSON.parse(storage) as boolean) : false;

  const [showPopup, setShowPopup] = useState<boolean>(!cookieConsent);

  function handleAccept() {
    localStorage.setItem('cookieConsent', JSON.stringify(true));
    setShowPopup(false);
  }

  if (showPopup) {
    return (
      <Card className="sticky left-0 bottom-0 w-[360px] h-[312px] z-50 bg-white text-sm  [&>p]:mb-4 p-12">
        <img src={cookiesImg} alt="cookie" className="absolute top-3 right-3 w-10 h-10" />
        <p>
          We use cookies to personalize content, utilize website traic analytics & support our marketing initiatives.
        </p>
        <p>
          By continuing to browse our site you consent to receive our cookies. For more information see our
          <button onClick={showCookieModal} type="button" className="link-button">
            Privacy and Cookie Statement.
          </button>
        </p>
        <div className="flex">
          <Button onClick={handleAccept}>Accept</Button>
        </div>
      </Card>
    );
  } else {
    return null;
  }
}
